import { createSelector } from 'reselect'

import { getGroupData } from '../../Core/Firebase/firebase.selectors'

export const getPlayerData = (state) => state.mars.indicators
export const getStoryLineIndicators = (state) => state.storyLine.indicators

export const getIndicators = createSelector(
  [getStoryLineIndicators, getPlayerData],
  (indicators, playerData) => {
    return Object.keys(indicators).map((i) => {
      return { ...indicators[i], value: playerData.userData[i] || 0 }
    })
  }
)

export const getUserData = createSelector([getPlayerData], (playerData) => {
  return playerData.userData
})

export const getVisitorData = createSelector([getPlayerData], (playerData) => {
  return playerData.visitorData
})

export const getVisitorIndicators = createSelector(
  [getStoryLineIndicators, getVisitorData],
  (indicators, visitorData) => {
    if (!visitorData) {
      return []
    }
    return Object.keys(indicators).map((i) => {
      return { ...indicators[i], value: visitorData[i] || 0 }
    })
  }
)
export const getDisplayingType = createSelector([getPlayerData], (playerData) => {
  return playerData.displayingType
})
export const getCountersData = createSelector([getPlayerData], (playerData) => {
  return playerData.userData.counters
})

export const getRelativeTurn = createSelector(
  [getUserData, getGroupData],
  ({ turn }, { maxTurns }) => (turn % maxTurns === 0 ? maxTurns : turn % maxTurns)
)
